import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const shopifyTemplate = {
	id: 'shopify',
	guid: 'a8c6f1cb-7bcf-4cc7-8fa6-e09cfd20cfdb',
	name: 'Shopify',
	category: TEMPLATE_CATEGORIES.ECOMMERCE,
	popularity: 'Growing',
	color: '#96bf48',
	icon: 'fab fa-shopify',
	description: 'E-commerce platform integration for product and order management.',
	features: ['OAuth2 Auth', 'Product Sync', 'Order Management', 'Customer Data'],
	configFields: [
		{ name: 'shopDomain', label: 'Shop Domain', type: 'text', required: true, placeholder: 'your-store.myshopify.com' },
		{ name: 'apiKey', label: 'API Key', type: 'text', required: true, placeholder: 'Enter your Shopify API key' },
		{ name: 'password', label: 'API Password', type: 'password', required: true, placeholder: 'Enter your Shopify API password' }
	],
	endpoints: [
		{
			name: 'Create Customer',
			url: 'https://{shop_domain}/admin/api/2023-07/customers.json',
			method: 'POST',
			description: 'Create a customer in Shopify',
			cassieObjectID: -3,
			incrementField: 'SyrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: '{ "customer": { "first_name": "[PLACEHOLDER_FORENAME]", "last_name": "[PLACEHOLDER_SURNAME]", "email": "[PLACEHOLDER_EMAIL1]" }}',
			headers: [
				{ Name: 'X-Shopify-Access-Token', value: '[API_KEY]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 201, message: 'Customer created' }]
		}
	],
	defaults: {
		endpointAddress: 'https://[shop-name].myshopify.com/admin/api/2023-01',
		authenticationUrl: 'https://[shop-name].myshopify.com/admin/oauth/authorize',
		authenticationTypeId: AUTH_TYPES.OAUTH2_CLIENT_CREDENTIALS,
		frequencyInSeconds: 0,
		auth2Scope: 'read_products,read_orders,read_customers',
		notes: 'Shopify e-commerce integration for product catalog and order management. Replace [shop-name] with your Shopify store name.'
	}
}
